import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  colorTrigger: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifySelf: 'center',
  },
  colorDot: {
    width: 20,
    height: 20,
    borderRadius: '50%',
    border: `2px solid ${theme.palette.grey[300]}`,
  },
}))

export default useStyles
